/* VAQIO theme — interactions (ported from React/Framer Motion) */
(function () {
  'use strict';

  /* ---------- header scroll state + sticky buy bar ---------- */
  var header = document.querySelector('.site-header');
  var stickyBuy = document.querySelector('.sticky-buy');
  function onScrollHeader() {
    var y = window.scrollY;
    if (header) header.classList.toggle('is-scrolled', y > 24);
    if (stickyBuy) stickyBuy.classList.toggle('is-visible', y > window.innerHeight * 1.2);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- reveal on scroll ---------- */
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal, .reveal-x, .reveal-scale').forEach(function (el) {
    revealObserver.observe(el);
  });

  /* stagger children marked with data-stagger */
  document.querySelectorAll('[data-stagger]').forEach(function (parent) {
    var i = 0;
    parent.querySelectorAll('.reveal, .reveal-x, .reveal-scale').forEach(function (child) {
      child.style.transitionDelay = (i * 0.08) + 's';
      i++;
    });
  });

  /* ---------- count-up numbers ---------- */
  var countObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      countObserver.unobserve(el);
      var to = parseFloat(el.getAttribute('data-to') || '0');
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1400;
      var start = performance.now();
      function tick(now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + (to * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.4 });

  document.querySelectorAll('.countup').forEach(function (el) { countObserver.observe(el); });

  /* ---------- parallax images ---------- */
  var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  function onScrollParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var rect = el.parentElement.getBoundingClientRect();
      var progress = 1 - (rect.top + rect.height / 2) / (vh + rect.height);
      progress = Math.max(0, Math.min(1, progress));
      var shift = (progress - 0.5) * 20; /* -10% .. +10% */
      el.style.transform = 'scale(1.25) translateY(' + shift + '%)';
    });
  }
  window.addEventListener('scroll', onScrollParallax, { passive: true });
  onScrollParallax();

  /* ---------- steps progress line ---------- */
  var stepsWrap = document.querySelector('[data-steps]');
  var stepsProgress = document.querySelector('.steps-progress');
  function onScrollSteps() {
    if (!stepsWrap || !stepsProgress) return;
    var rect = stepsWrap.getBoundingClientRect();
    var vh = window.innerHeight;
    var progress = (vh * 0.85 - rect.top) / (rect.height + vh * 0.4);
    progress = Math.max(0, Math.min(1, progress));
    stepsProgress.style.transform = 'scaleY(' + progress + ')';
  }
  window.addEventListener('scroll', onScrollSteps, { passive: true });
  onScrollSteps();

  /* ---------- hero parallax on scroll ---------- */
  var hero = document.querySelector('.hero');
  var heroImg = document.querySelector('.hero-visual');
  var heroText = document.querySelector('.hero-copy');
  function onScrollHero() {
    if (!hero) return;
    if (window.innerWidth < 1024) {
      if (heroImg) heroImg.style.transform = '';
      if (heroText) heroText.style.transform = '';
      return;
    }
    var rect = hero.getBoundingClientRect();
    if (rect.bottom < 0) return;
    var p = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
    if (heroImg) heroImg.style.transform = 'translateY(' + (p * 18) + '%)';
    if (heroText) heroText.style.transform = 'translateY(' + (p * 40) + '%)';
  }
  window.addEventListener('scroll', onScrollHero, { passive: true });

  /* ---------- buy section: variant picker + AJAX add to cart ---------- */
  var buyForm = document.getElementById('buy-form');
  if (buyForm) {
    var variantsEl = document.getElementById('variant-data');
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    var variantInput = document.getElementById('variant-id');

    document.querySelectorAll('.color-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.color-opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var color = btn.getAttribute('data-color');
        var match = variants.find(function (v) {
          return v.options && v.options.some(function (o) { return o.toLowerCase() === color.toLowerCase(); });
        });
        if (match && variantInput) {
          variantInput.value = match.id;
          var priceEl = document.querySelector('.buy-price .now');
          if (priceEl && match.price != null) {
            priceEl.textContent = (match.price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            priceEl.textContent = priceEl.getAttribute('data-currency') + priceEl.textContent;
          }
        }
      });
    });

    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = buyForm.querySelector('.btn-red');
      var msg = document.querySelector('.buy-message');
      var original = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      var data = { items: [{ id: parseInt(variantInput.value, 10), quantity: 1 }] };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        btn.textContent = '✓ Added — nice choice';
        if (msg) msg.textContent = 'Added to your cart.';
        setTimeout(function () { window.location.href = '/cart'; }, 300);
      }).catch(function () {
        buyForm.submit = null;
        btn.disabled = false;
        btn.innerHTML = original;
        buyForm.removeEventListener('submit', arguments.callee);
        HTMLFormElement.prototype.submit.call(buyForm);
      });
    });
  }
})();

/* ============================================================
   PRODUCT LANDING — gallery, variants, accordion
   ============================================================ */
(function () {
  'use strict';

  /* ---------- PDP variant selector + add to cart ---------- */
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    var variantsEl = document.getElementById('pdp-variant-data');
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    var variantInput = document.getElementById('pdp-variant-id');
    var selected = [];

    /* init from first available variant */
    var firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
    if (firstAvailable) selected = firstAvailable.options.slice();

    function syncUI() {
      document.querySelectorAll('.pdp-option').forEach(function (group, gi) {
        group.querySelectorAll('.pdp-opt').forEach(function (btn) {
          btn.classList.toggle('active', btn.getAttribute('data-value') === selected[gi]);
        });
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      var btn = pdpForm.querySelector('.btn-red');
      var priceNow = document.querySelector('.pdp-price .now');
      if (match) {
        variantInput.value = match.id;
        if (priceNow && match.price != null) {
          priceNow.textContent = window.pdpMoneyFormat
            ? window.pdpMoneyFormat.replace(/\{\{\s*amount\s*\}\}/, (match.price / 100).toFixed(0))
            : match.price / 100;
        }
        btn.classList.toggle('is-soldout', !match.available);
        btn.textContent = match.available ? btn.getAttribute('data-label') : 'Sold out';
      }
    }

    document.querySelectorAll('.pdp-option').forEach(function (group) {
      var gi = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('.pdp-opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[gi] = btn.getAttribute('data-value');
          syncUI();
        });
      });
    });
    syncUI();

    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pdpForm.querySelector('.btn-red');
      var msg = document.querySelector('.pdp-message');
      if (btn.classList.contains('is-soldout')) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantInput.value, 10), quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      }).then(function () {
        btn.textContent = '✓ Added — nice choice';
        if (msg) msg.textContent = 'Added to your cart.';
        setTimeout(function () { window.location.href = '/cart'; }, 300);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-label');
        if (msg) msg.textContent = 'Could not add — please try again.';
      });
    });
  }

  /* ---------- PDP accordions ---------- */
  document.querySelectorAll('.pdp-acc-item').forEach(function (item) {
    var head = item.querySelector('.pdp-acc-head');
    var body = item.querySelector('.pdp-acc-body');
    head.addEventListener('click', function () {
      var open = item.classList.toggle('open');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    });
  });

  /* ---------- recommendations (Shopify API) ---------- */
  var recsSection = document.querySelector('[data-recommendations]');
  if (recsSection) {
    var productId = recsSection.getAttribute('data-product-id');
    var limit = recsSection.getAttribute('data-limit') || 4;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var grid = recsSection.querySelector('.recs-grid');
        if (!grid || !data.products || !data.products.length) {
          recsSection.style.display = 'none';
          return;
        }
        grid.innerHTML = data.products.map(function (p) {
          var img = p.featured_image
            ? '<img src="' + p.featured_image.replace(/\.(\w+)(\?|$)/, '_600x600.$1$2') + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
            : '';
          var price = (p.price / 100).toFixed(0);
          return '<a class="rec-card reveal in-view" href="' + p.url + '">' +
            '<span class="img-wrap">' + img + '</span>' +
            '<span class="title">' + p.title + '</span>' +
            '<span class="price">' + recsSection.getAttribute('data-currency') + price + '</span>' +
            '<span class="go">View product <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></span>' +
            '</a>';
        }).join('');
      })
      .catch(function () { recsSection.style.display = 'none'; });
  }
})();

/* ============================================================
   GALLERY REBUILD — variant image switching, preload, fade
   ============================================================ */
(function () {
  'use strict';
  var mainImg = document.getElementById('gallery-main-img');
  var variantsEl = document.getElementById('pdp-variant-data');
  if (!mainImg || !variantsEl) return;

  var variants = [];
  try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

  /* preload every variant image so switching is instant */
  variants.forEach(function (v) {
    if (v.image) { var i = new Image(); i.src = v.image; }
  });

  function switchImage(src, alt) {
    if (!src) return;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (mainImg.src === src) return;
    mainImg.classList.add('is-switching');
    var done = false;
    function finish(ok) {
      if (done) return;
      done = true;
      if (ok) { mainImg.src = src; if (alt) mainImg.alt = alt; }
      mainImg.classList.remove('is-switching');
    }
    var pre = new Image();
    pre.onload = function () { finish(true); };
    pre.onerror = function () { finish(false); };
    pre.src = src;
    setTimeout(function () { finish(true); }, 4000);
    /* sync active thumbnail (normalize protocol-relative data-full) */
    document.querySelectorAll('.gallery-thumb').forEach(function (t) {
      var full = t.getAttribute('data-full') || '';
      if (full.indexOf('//') === 0) full = 'https:' + full;
      t.classList.toggle('active', full === src);
    });
  }

  function activeThumbIndex() {
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var cur = mainImg.src;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('active')) return i;
      var full = thumbs[i].getAttribute('data-full') || '';
      if (full.indexOf('//') === 0) full = 'https:' + full;
      if (full === cur) return i;
    }
    return -1;
  }

  function selectedOptions() {
    var opts = [];
    document.querySelectorAll('.pdp-option').forEach(function (group) {
      var active = group.querySelector('.pdp-opt.active');
      opts.push(active ? active.getAttribute('data-value') : null);
    });
    return opts;
  }

  function currentVariant() {
    var sel = selectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }

  /* swatch click → switch to that variant's image */
  document.querySelectorAll('.pdp-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      /* let the main syncUI run first (same tick is fine) */
      var match = currentVariant();
      if (match && match.image) switchImage(match.image, match.image_alt);
    });
  });

  /* thumbnail click → switch image (kept from before, now with fade) */
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      switchImage(thumb.getAttribute('data-full'), thumb.getAttribute('data-alt'));
    });
  });

  /* ── swipe left/right on the main image, one picture per swipe ── */
  var mainWrap = document.querySelector('.gallery-main');
  if (mainWrap) {
    var touchX = null, touchY = null, swipeLock = false, gesture = null;
    function stepImage(dir) {
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
      if (!thumbs.length) return;
      var idx = activeThumbIndex();
      if (idx < 0) idx = 0;
      var next = idx + dir;
      if (next < 0 || next >= thumbs.length) return; /* stop at ends, no rotation */
      thumbs[next].click();
    }
    mainWrap.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { touchX = null; gesture = null; return; }
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
      gesture = null; /* undecided until the finger moves */
    }, { passive: true });
    mainWrap.addEventListener('touchmove', function (e) {
      if (touchX === null || gesture === 'scroll') return;
      var dx = e.touches[0].clientX - touchX;
      var dy = e.touches[0].clientY - touchY;
      if (gesture === null) {
        /* decide early: mostly-vertical movement = page scroll, ignore it */
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { gesture = 'scroll'; return; }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.5) gesture = 'swipe';
      }
      if (gesture === 'swipe' && e.cancelable) e.preventDefault(); /* stop page wobble while swiping */
    }, { passive: false });
    mainWrap.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var wasSwipe = gesture === 'swipe';
      touchX = null; gesture = null;
      if (!wasSwipe || swipeLock) return;
      if (Math.abs(dx) > 40) {
        swipeLock = true; /* one image per swipe — no rapid skipping */
        stepImage(dx < 0 ? 1 : -1);
        setTimeout(function () { swipeLock = false; }, 450);
      }
    }, { passive: true });
  }
})();
